// extracted by mini-css-extract-plugin
module.exports = {"whole":"CreateInformationPage_whole__3Ek_P","middle-section":"CreateInformationPage_middle-section__j2_7l"};